import { PromoModalType } from "@faire/web-api--source/indigofair/data/PromoModalType";
import { getWindowOrThrow } from "@faire/web/common/globals/getWindow";
import { parseQueryParams } from "@faire/web/common/query-params/parseQueryParams";

import { IGateHook } from "./type";
import { useModalType } from "./useModalType";

export const useTermsPreApprovalGate: IGateHook = () => {
  const modalType = useModalType();

  const searchParamsContain = (param: string) =>
    !!parseQueryParams(getWindowOrThrow().location.search).get(param);

  if (
    !searchParamsContain("termsPreApproval") &&
    modalType === PromoModalType.TERMS_PRE_APPROVAL_LANDING_MODAL
  ) {
    return PromoModalType.TERMS_PRE_APPROVAL_LANDING_MODAL;
  }

  return undefined;
};
